import { render, staticRenderFns } from "./TestPC.vue?vue&type=template&id=9c767512&scoped=true"
import script from "./TestPC.vue?vue&type=script&lang=js"
export * from "./TestPC.vue?vue&type=script&lang=js"
import style0 from "./TestPC.vue?vue&type=style&index=0&id=9c767512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c767512",
  null
  
)

export default component.exports